// import RedisService from './redis';
// import { sessionOptions } from "@/pages/api/getAccessToken";
// import { getIronSession } from "iron-session";

import { AttchmentData, BroFormData } from "@/types/common";
import { buildHeaders, getApiBaseUrl } from "@/utils/getApiBaseUrl";

export const articleService = {
  getArticleDataByFullPath: async (
    slug: string,
    isBroDoneFlag?: number,
    host?: string
    ,isExternal:boolean=false
  ) => {
    try {
      const requestUrl = `${getApiBaseUrl(host,isExternal) || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/${slug}?isBroDoneFlag=${isBroDoneFlag}`;
      const requestHeaders = buildHeaders('', 'getArticleDataByFullPath', host);

      const response = await fetch(requestUrl, {
        headers: requestHeaders,
        cache: 'no-store',
        next: { revalidate: 0 }, // Cache for 30 seconds
      });

      if (response.status === 404 && typeof window === 'undefined') {
        const requestId = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        try {
          const responseClone = response.clone();
          const responseText = await responseClone.text();
          const contentType = response.headers.get('content-type') || undefined;

          let parsedBody: any = responseText;
          if (typeof responseText === 'string' && contentType?.includes('application/json')) {
            try {
              parsedBody = JSON.parse(responseText);
            } catch {
              parsedBody = responseText;
            }
          }

          const sanitizedHeaders: Record<string, any> = {};
          for (const [k, v] of Object.entries(requestHeaders || {})) {
            const key = k.toLowerCase();
            if (key === 'authorization' || key === 'cookie' || key === 'set-cookie') {
              sanitizedHeaders[k] = '[redacted]';
            } else {
              sanitizedHeaders[k] = v;
            }
          }

          const { appendFileSync, mkdirSync } = await import('fs');
          const path = await import('path');
          const logDir = path.resolve(process.cwd(), 'logs');
          mkdirSync(logDir, { recursive: true });
          const logPath = path.resolve(logDir, 'api-404.log');

          appendFileSync(
            logPath,
            `${JSON.stringify({
              timestamp: new Date().toISOString(),
              request: {
                id: requestId,
                method: 'GET',
                url: requestUrl,
                headers: sanitizedHeaders,
                query: { isBroDoneFlag },
              },
              response: {
                statusCode: 404,
                contentType,
                body: parsedBody,
              },
            })}\n`,
            'utf8'
          );
        } catch {
          const _ = 0;
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(
        "getArticleDataByFullPathError fetching Article data:",
        error
      );
      return null;
    }
  },

  getArticleDataById: async (postId: number, host?: string) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/get-by-id/${postId}`,
        {
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(
        "getArticleDataByFullPathError fetching Article data:",
        error
      );
      return null;
    }
  },

  getTrendingArticle: async (slug: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/trending/${slug}`,
        {
          headers: buildHeaders('', 'getTrendingArticle',''),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getTrendingArticle Error fetching Article data:", error);
      return null;
    }
  },
  getRelatedArticle: async (slug: string, host?: string
    ,isExternal:boolean=false) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl(host,isExternal) || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/related/${slug}`,
        {
          headers: buildHeaders('', 'getRelatedArticle',''),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getRelatedArticle Error fetching Article data:", error);
      return null;
    }
  },
  getSuggestedArticles: async (slug: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/suggested/${slug}`,
        {
          headers: buildHeaders('', 'getSuggestedArticles', ''),
          cache: 'no-store',
          next: { revalidate: 0 },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getSuggestedArticles Error:", error);
      return null;
    }
  },
  getArticlePreview: async (postId: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/preview/${postId}`,
        {
          headers: buildHeaders('', 'getArticlePreview',''),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getArticlePreview Error fetching Article data:", error);
      return null;
    }
  },
  broFormSubmit: async (formData: BroFormData) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/bro-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...buildHeaders('', 'broFormSubmit',''),
          },
          body: JSON.stringify(formData),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error submitting BRO form:", error);
      throw error; // Re-throw to handle in the calling component
    }
  },

  attachmentDownload: async (formData: AttchmentData) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/download-attachment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${formData.token}`,
            ...buildHeaders(formData.token,'attachmentDownload',''),
          },
          body: JSON.stringify(formData),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(
        "Error submitting Article Attachment Download form:",
        error
      );
      throw error; // Re-throw to handle in the calling component
    }
  },

  articleBookmark: async (postId: number, token: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/save-wishlist-article`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token,'articleBookmark',''),
          },
          body: JSON.stringify({
            fk_post_id: postId,
          }),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(
        "Error submitting Article Attachment Download form:",
        error
      );
      throw error; // Re-throw to handle in the calling component
    }
  },
  getBookmarkArticle: async ({
    postId,
    token,
    pageNo,
    pageSize,
  }: {
    postId?: number;
    token: string;
    pageNo?: number;
    pageSize?: number;
  }) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/get-wishlist-article?fk_post_id=${postId}&pageNo=${pageNo}&pageSize=${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token,'getBookmarkArticle',''),
          },
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(
        "Error submitting Article Attachment Download form:",
        error
      );
      throw error; // Re-throw to handle in the calling component
    }
  },

  getNextArticle: async (
    slug: string,
    excludePostIds: number[],
    host?: string
  ) => {
    try {
      const query = excludePostIds.length
        ? `?exclude_post_ids=${excludePostIds.join(",")}`
        : "";
      const response = await fetch(
        `${getApiBaseUrl(host) || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/next-article/${encodeURIComponent(slug)}${query}`,
        {
          headers: buildHeaders("", "getNextArticle", host),
          cache: "no-store",
          next: { revalidate: 0 },
        }
      );

      // The endpoint may be missing/erroring on some environments — Express
      // returns an HTML 404 ("Cannot GET ...") which is not JSON. Guard the
      // parse so the scroll degrades to "no next article" instead of throwing
      // "Unexpected token '<'".
      const contentType = response.headers.get("content-type") || "";
      if (!response.ok || !contentType.includes("application/json")) {
        console.warn(
          `getNextArticle: non-JSON response (status ${response.status}) for slug "${slug}"`
        );
        return { success: false, data: { article: null, hasNext: false } };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getNextArticle Error:", error);
      return { success: false, data: { article: null, hasNext: false } };
    }
  },

  getArticleViewCount: async (slug: string, host?: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl(host) || process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/view-count/${slug}`,
        {
          headers: buildHeaders('', 'getArticleViewCount', host),
          cache: 'no-store',
          next: { revalidate: 0 }, // No caching
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching article view count:", error);
      return null;
    }
  },
};
